import { useContext } from 'react';

import { ConnectContext, ConnectContextValue } from './ConnectContext';

/**
 * Read the embedded Amazon Connect softphone state and actions.
 *
 * Throws if called outside ConnectProvider — every consumer must live below
 * the provider in the tree, which currently sits inside MainLayout.
 */
export const useConnect = (): ConnectContextValue => {
  const ctx = useContext(ConnectContext);
  if (!ctx) {
    throw new Error('useConnect must be used inside ConnectProvider');
  }
  return ctx;
};

/**
 * Variant for components that may render outside the provider (e.g. a
 * generic phone-number atom rendered before MainLayout has mounted, or for
 * users without the softphone permission). Returns null instead of throwing
 * so callers can degrade gracefully to a plain `tel:` link.
 */
export const useConnectOptional = (): ConnectContextValue | null => useContext(ConnectContext);
